
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/folder/[name]",
      function () {
        return require("private-next-pages/folder/[name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/folder/[name]"])
      });
    }
  